import { ProfileStatisticsDto } from './profile-statistics.dto';

export class ProfileStatistics {
    readonly completedCourses: number;
    readonly hoursOfStudy: number;
    readonly daysInARow: number;
    readonly certificates: number;
    readonly lastActivity: Date | null;
    readonly longestStreak: number;
    readonly averageStudyTime: number;

    constructor(dto: ProfileStatisticsDto) {
        this.completedCourses = dto.completedCourses;
        this.hoursOfStudy = dto.hoursOfStudy;
        this.daysInARow = dto.daysInARow;
        this.certificates = dto.certificates;
        this.lastActivity = dto.lastActivity ? new Date(dto.lastActivity) : null;
        this.longestStreak = dto.longestStreak;
        this.averageStudyTime = dto.averageStudyTime;
    }
}
